fx.ns("common.popups", class WrongFilePopup extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personAdvice );
        this.contentWidth = 550;
        this.contentHeight = 250;
       
        this.closeOnClickBehind = true;
    }


    create()
    {
        super.create();

        this.title = new fx.components.Text({text:fx.text("Le format de fichier que vous avez sélectionné est incorrect"), className:"title center"});
        this.text = new fx.components.Text({text:fx.text("Veuillez choisir un fichier avec une extension valide (.pdf)"), className:"text center"});
        this.okButton = new fx.components.Button({label : fx.text("J'ai compris"), className: "filled"});
        
        this.addChild(this.title);
        this.addChild(this.text);
        this.addFooterChild(this.okButton, {width : 280});
        
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
        this.on("ENTER", this.close, fx.keyboard);
    }

});